<template>
  <div class="m-4">
    <div class="container">
      <h3 class="text-center p-2">Visualizzazione dicom</h3>
      <a :href="backUrl" class="btn btn-secondary mb-2">Torna indietro</a>
      <!-- i frame -->
      <div class="text-center" v-if="fullUrl != ''">
        <iframe :src="fullUrl" width="400" height="400"></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import httpauth from "@/services/httpauth.js";
import { useAuth } from "@/stores/auth.js";
export default {
  name: "DicomPage",
  props: ["id"],
  data() {
    return {
      dicoms: [],
      loading: true,
      domain: "",
      url: "",
      fullUrl: "",
      backUrl: ""
    };
  },
  mounted() {
    console.log('ID: ' + this.id);
    httpauth
      .get("/attachments-activity/" + this.id)
      .then((response) => {
        this.backUrl = response.data.data.back_url;
      })
      .catch((error) => {
        if (
          error.response.status == 401 &&
          error.response.data.message == "Unauthenticated."
        )
        {
          const auth = useAuth();
          auth.clearToken();
          window.location.href = "/";
        } else if (error.response.status == 404)
        {
          console.log('eeeee');
          //window.location.href = "/";
        }
      });
    switch (window.location.hostname)
    {
      case "localhost":
        this.domain = "http://localhost";
        this.url = "http://localhost:8080";
        break;
      case "demo.vascularclass.it":
        this.domain = "https://test.gestione.vascularclass.it";
        this.url = "https://demo-dicom-viewer-du674cefya-oc.a.run.app";
        break;
      case "www.vascularclass.it":
      case "vascularclass.it":
        this.domain =
          "https://gestione.vascularclass.it";
        this.url = "https://dicom-viewer-du674cefya-oc.a.run.app";
        break;
    }
    const token = localStorage.getItem("token");
    this.fullUrl =
      this.url +
      "?domain=" +
      this.domain +
      "&id=" +
      this.id +
      "&token=" +
      token;
  },
};
</script>